import { SetState } from '@pages/Organization/utils/onOrgNameSubmit';
import { IPicture } from '@models/Picture.model';
import {
  PicturesList,
  PictureButton,
  PictureItem,
  PicturesWrapper,
} from './PicturesOverview.styles';

interface ListPictureProps {
  setSelectedPicture: SetState<string>;

  data: IPicture[];
  selectedPicture: string;
}
export function ListPictures({
  setSelectedPicture,
  data,
  selectedPicture,
}: ListPictureProps) {
  return (
    <PicturesList>
      {data.map(item => {
        return (
          <PicturesWrapper key={item.id}>
            <PictureButton
              onClick={() => {
                setSelectedPicture(item.id);
              }}
              data-selected={selectedPicture === item.id}
            >
              <PictureItem
                src={item.type === 'uri' ? item.uri : item.file?.uri}
              />
            </PictureButton>
          </PicturesWrapper>
        );
      })}
    </PicturesList>
  );
}
